import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { StaggerCss } from '@mentimeter/question-modules-shared';
import React from 'react';
import { Label } from '@mentimeter/slides-presentation-ui/title/label';
import { Box } from '@mentimeter/ragnar-ui/box';
import { MarkdownText } from '@mentimeter/slides-presentation-ui/text/markdown-text';
import { getNinePointLayoutProperties } from '../../shared/utils/getNinePointLayoutProperties';
import { BigText } from './big-text/BigText';

export function BigPresentation() {
  const { useQuestion, useConfig } = usePresentationContext();

  const question = useQuestion();
  const title = question.question;
  const { enableAnimations } = useConfig();

  const { textAlign, justifyContent, alignItems } =
    getNinePointLayoutProperties(question.layout);

  return (
    <Box
      width="100%"
      height="90%"
      data-testid="big-container"
      alignItems={alignItems}
      justifyContent="center"
    >
      <StaggerCss index={1} enableAnimations={enableAnimations}>
        {question.title_meta && (
          <Label>
            <MarkdownText
              disableLineBreaks
              source={question.title_meta}
              allowHyperlinks
            />
          </Label>
        )}

        <BigText
          key={question.id}
          text={title}
          textAlign={textAlign}
          justifyContent={justifyContent}
        >
          <MarkdownText
            source={title}
            disableLineBreaks={false}
            allowBlankLines
            allowHyperlinks
          />
        </BigText>
      </StaggerCss>
    </Box>
  );
}
